/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UboDeclarationResponseCompany
 */
export interface UboDeclarationResponseCompany {
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseCompany
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseCompany
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseCompany
     */
    formattedAddress: string;
    /**
     * 
     * @type {string}
     * @memberof UboDeclarationResponseCompany
     */
    signatureLocation: string;
}

/**
 * Check if a given object implements the UboDeclarationResponseCompany interface.
 */
export function instanceOfUboDeclarationResponseCompany(value: object): value is UboDeclarationResponseCompany {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    if (!('signatureLocation' in value) || value['signatureLocation'] === undefined) return false;
    return true;
}

export function UboDeclarationResponseCompanyFromJSON(json: any): UboDeclarationResponseCompany {
    return UboDeclarationResponseCompanyFromJSONTyped(json, false);
}

export function UboDeclarationResponseCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UboDeclarationResponseCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'registrationNumber': json['registrationNumber'],
        'formattedAddress': json['formattedAddress'],
        'signatureLocation': json['signatureLocation'],
    };
}

export function UboDeclarationResponseCompanyToJSON(value?: UboDeclarationResponseCompany | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'registrationNumber': value['registrationNumber'],
        'formattedAddress': value['formattedAddress'],
        'signatureLocation': value['signatureLocation'],
    };
}

